import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function Receipts() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M6.892 3.203a.842.842 0 00-1.392.64v16.314a.844.844 0 001.392.64l1.42-1.217 1.421 1.217c.316.27.784.27 1.097 0l1.42-1.217 1.42 1.217c.317.27.785.27 1.098 0l1.42-1.217 1.42 1.217a.842.842 0 001.393-.64V3.843a.844.844 0 00-1.392-.64l-1.42 1.217-1.421-1.217a.842.842 0 00-1.097 0L12.25 4.42 10.83 3.203a.842.842 0 00-1.097 0L8.313 4.42l-1.42-1.217zm.296 15.119V5.678l.576.493c.317.27.784.27 1.097 0l1.42-1.217 1.421 1.217c.316.27.784.27 1.097 0l1.42-1.217 1.42 1.217c.317.27.785.27 1.098 0l.576-.493v12.643l-.576-.492a.842.842 0 00-1.097 0l-1.42 1.217-1.421-1.217a.842.842 0 00-1.097 0l-1.42 1.217-1.42-1.217a.842.842 0 00-1.098 0l-.576.492zm2.531-10.26a.842.842 0 00-.844.844c0 .468.376.844.844.844h5.063a.842.842 0 00.844-.844.842.842 0 00-.844-.844H9.719zm0 6.188a.842.842 0 00-.844.844c0 .468.376.844.844.844h5.063a.842.842 0 00.844-.844.842.842 0 00-.844-.844H9.719zM8.875 12c0 .468.376.844.844.844h5.063a.842.842 0 00.844-.844.842.842 0 00-.844-.844H9.719a.842.842 0 00-.844.844z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const ReceiptsIcon = React.memo(Receipts);

export default ReceiptsIcon;
